export const RATHER_NOT_SAY = 'RATHER_NOT_SAY';
